import { clearStoredTokens } from "./use-auth-tokens.js";
import { performRefresh } from "../util/tokens.js";
import { useEffect } from "react";

//#region src/client/hooks/use-refresh-expired-token.ts
/**
* Exchanges the refresh token for a new access token as soon as the stored
* access token has expired, so a patient with a usable refresh token stays on
* the page. This runs whether or not the heartbeat is enabled.
*
* A failed refresh clears the stored tokens, which flips `isAuthenticated` to
* false. Protected routes then start the login challenge with the current
* path, so a deep link is kept.
*/
const useRefreshExpiredToken = ({ clientId, isAccessTokenExpired, refreshToken, tokenUrl }) => {
	useEffect(() => {
		if (!isAccessTokenExpired || !refreshToken) return;
		performRefresh(refreshToken, clientId, tokenUrl).catch(() => {
			clearStoredTokens();
		});
	}, [
		clientId,
		isAccessTokenExpired,
		refreshToken,
		tokenUrl
	]);
};

//#endregion
export { useRefreshExpiredToken };